function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_advancedsignup:customdeploy_ns_sc_ext_sl_advancedsignup":"/app/site/hosting/scriptlet.nl?script=4672&deploy=1&compid=4347112&ns-at=AAEJ7tMQrWBSwyvPfSlJK3gca23zWNEjqCkCKM5NK1O2NfoNGlI","customscript_ns_sc_ext_sl_newsletter_sp:customdeploy_ns_sc_ext_sl_newsletter_sp":"/app/site/hosting/scriptlet.nl?script=320&deploy=1&compid=4347112&ns-at=AAEJ7tMQbArxRI4QaWqSZaM73V-FVUWyDjaj9NyjRd2TYJoTNdo","customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=1886&deploy=1&compid=4347112&ns-at=AAEJ7tMQbylhNUA3H87e0cDkiCec-YaZ8FNw4-Uw6RhO6XD4o2Y","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=1888&deploy=1&compid=4347112&ns-at=AAEJ7tMQkKtr06Z5MA-g9HlNi90RTfH9z-aK3Szk_mek6yojepw","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=1887&deploy=1&compid=4347112&ns-at=AAEJ7tMQ7PUpJ4akupqYrij6ZkJeMLraQUhkUZTJJx9v1QxSeKU","customscript_ns_sc_sl_gift_cert_balance:customdeploy_ns_sc_sl_gift_cert_balance":"/app/site/hosting/scriptlet.nl?script=1104&deploy=1&compid=4347112&ns-at=AAEJ7tMQeqj5fRpW8AhnRiCsPE160cUzFevCtAOuwwcYd-Zo1SM","customscript_ns_sc_sl_gift_cert_groups:customdeploy_ns_sc_sl_gift_cert_groups":"/app/site/hosting/scriptlet.nl?script=1103&deploy=1&compid=4347112&ns-at=AAEJ7tMQsvk4k-87m6ix7m_inQ55Tn_hjzK4Hkx1FJjj1pETFgU","customscript_ns_sc_sl_gift_cert_mgmt:customdeploy_ns_sc_sl_gift_cert_mgmt":"/app/site/hosting/scriptlet.nl?script=1105&deploy=1&compid=4347112&ns-at=AAEJ7tMQGwq4nyya33iFMjg_B1vMygCMrSmOYO7duSvXbZrzOCs","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=392&deploy=1&compid=4347112&ns-at=AAEJ7tMQqbn2r7UdCuy-0sReXjatnu0kYJxnk-WkDSaH-a4_0x8"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}